export default __webpack_public_path__ + "static/media/solana-sol-logo.b612f140.svg";